import { math } from '../math';

function toHexComponent(v:number){
	return v.toString(16).padStart(2,'0');
}

function hsvToRgb(
	h:number,
	s:number,
	v:number,
):[number,number,number]{
	h??=0;
	s??=0;
	v??=0;
	if(s<=0)
		return [v,v,v];

	let r=0,g=0,b=0;
	let hh=h;
	if(hh>=360.0)
		hh=0;
	hh/=60.0;
	let i=Math.floor(hh);
	let ff=hh-i;
	let p=v*(1.0-s);
	let q=v*(1.0-(s*ff));
	let t=v*(1.0-(s*(1.0-ff)));

	switch(i){
	case 0:
		r=v;
		g=t;
		b=p;
		break;
	case 1:
		r=q;
		g=v;
		b=p;
		break;
	case 2:
		r=p;
		g=v;
		b=t;
		break;

	case 3:
		r=p;
		g=q;
		b=v;
		break;
	case 4:
		r=t;
		g=p;
		b=v;
		break;
	case 5:
	default:
		r=v;
		g=p;
		b=q;
		break;
	}
	return [r,g,b];
}

export class Color{
	public readonly r:number;
	public readonly g:number;
	public readonly b:number;
	public readonly a:number;
	private _hue?:number;
	private _sat?:number;
	private _val?:number;

	public constructor(
		isRGB:true,
		x:number,
		y:number,
		z:number,
		a:number
	){
		this.a=a;
		this.r=x;
		this.g=y;
		this.b=z;
	}

	private updateHSV(){
		if(this._hue===undefined){
			const r=this.r,g=this.g,b=this.b;
			const min=Math.min(r,g,b);
			const max=Math.max(r,g,b);

			let h=0,s=0,v=0;
			v=max;
			const delta=max-min;
			if(delta<0.00001 || max<=0){
				//the color is a shade of gray
				h=0;
				s=0;
			}else{
				s=(delta/max);
				if(r==max)
					h=(g-b)/delta;// between yellow & magenta
				else if(g==max)
					h=2.0+(b-r)/delta;// between cyan & yellow
				else
					h=4.0+(r-g)/delta;// between magenta & cyan

				h*=60.0;// degrees

				if(h<0)
					h+=360;

			}
			this._hue=h;
			this._sat=s;
			this._val=v;
		}
	}

	// private updateRGB(){
	// 	let h=this._hue ?? 0,s=this._sat ?? 0,v=this._val ?? 0;
	// 	if(s<=0){
	// 		this.r=this.g=this.b=v;
	// 	}else{
	// 		let r=0,g=0,b=0;
	// 		let hh=h;
	// 		if(hh>=360.0)
	// 			hh=0;
	// 		hh/=60.0;
	// 		let i=Math.floor(hh);
	// 		let ff=hh-i;
	// 		let p=v*(1.0-s);
	// 		let q=v*(1.0-(s*ff));
	// 		let t=v*(1.0-(s*(1.0-ff)));

	// 		switch(i){
	// 		case 0:
	// 			r=v;
	// 			g=t;
	// 			b=p;
	// 			break;
	// 		case 1:
	// 			r=q;
	// 			g=v;
	// 			b=p;
	// 			break;
	// 		case 2:
	// 			r=p;
	// 			g=v;
	// 			b=t;
	// 			break;

	// 		case 3:
	// 			r=p;
	// 			g=q;
	// 			b=v;
	// 			break;
	// 		case 4:
	// 			r=t;
	// 			g=p;
	// 			b=v;
	// 			break;
	// 		case 5:
	// 		default:
	// 			r=v;
	// 			g=p;
	// 			b=q;
	// 			break;
	// 		}
	// 		this.r=r;
	// 		this.g=g;
	// 		this.b=b;
	// 	}
	// }

	public JSONParams(){
		return [true,this.r,this.g,this.b,this.a];
	}

	// public clone(){
	// 	return new Color(true,this.r,this.g,this.b,this.a);
	// }

	// public copy(that:Color){
	// 	this.r=that.r;
	// 	this.b=that.b;
	// 	this.g=that.g;
	// 	this.a=that.a;
	// 	this.clearHSV();
	// 	return this;
	// }

	public eq(that:Color|Color.Name){
		if(typeof(that)==='string')
			that=Color.named[that];
		return that && this.r===that.r && this.g===that.g && this.b===that.b && this.a===that.a;
	}

	// private rgbComponent(key:'r'|'g'|'b'){
	// 	// if(typeof(v)==='number'){
	// 	// 	v=Math.min(Math.max(v,0),1);
	// 	// 	if(this[key]!==v){
	// 	// 		this[key]=v;
	// 	// 		this.clearHSV();
	// 	// 	}
	// 	// 	return this;
	// 	// }
	// 	return this[key];
	// }

	// public red():number;
	// public red(v?:number){
	// 	return this.r;
	// }

	// public green():number;
	// public green(v:number):this;
	// public green(v?:number){
	// 	return this.rgbComponent('g',v);
	// }

	// public blue():number;
	// public blue(v:number):this;
	// public blue(v?:number){
	// 	return this.rgbComponent('b',v);
	// }

	// public get red(){
	// 	return this.r;
	// }

	// public get green(){
	// 	return this.g;
	// }

	// public get blue(){
	// 	return this.g;
	// }

	// public get alpha(){
	// 	return this.a;
	// }

	public get h(){
		this.updateHSV();
		return this._hue;
	}

	public get s(){
		this.updateHSV();
		return this._sat;
	}

	public get v(){
		this.updateHSV();
		return this._val;
	}

	// public rgb(values:{
	// 	r?:number,
	// 	g?:number,
	// 	b?:number,
	// 	a?:number,
	// }){
	// 	values={
	// 		r: values.r ?? this.r,
	// 		g: values.g ?? this.g,
	// 		b: values.b ?? this.b,
	// 		a: values.a ?? this.a,
	// 	};
	// 	return new Color(true,values.r,values.g,values.b,values.a);
	// }

	public alpha():number;
	public alpha(v:number):Color;
	public alpha(v?:number){
		if(v!==undefined)
			return new Color(true,this.r,this.g,this.b,math.clamp(v,0,1));
		return this.a;
	}

	public hue():number;
	public hue(v:number):Color;
	public hue(v?:number){
		if(v!==undefined){
			v%=360;
			if(v<0)
				v+=360;
			const [r,g,b]=hsvToRgb(v,this.s ?? 0,this.v ?? 0);
			return new Color(true,r,g,b,this.a);
		}
		return this.h;
	}

	public sat():number;
	public sat(v:number):Color;
	public sat(v?:number){
		if(v!==undefined){
			const [r,g,b]=hsvToRgb(this.h ?? 0,math.clamp(v,0,1),this.v ?? 0);
			return new Color(true,r,g,b,this.a);
		}
		return this.s;
	}

	public val():number;
	public val(v:number):Color;
	public val(v?:number){
		if(v!==undefined){
			const [r,g,b]=hsvToRgb(this.h ?? 0,this.s ?? 0,math.clamp(v,0,1));
			return new Color(true,r,g,b,this.a);
		}
		return this.v;
	}

	// public rgb(r:number, g:number, b:number, a?:number):this;
	// public rgb(array:number[]):this;
	// public rgb(r:number|number[],g?:number,b?:number,a?:number){
	// 	if(Array.isArray(r)){
	// 		this.r=r[0] ?? 0;
	// 		this.g=r[1] ?? 0;
	// 		this.b=r[2] ?? 0;
	// 		this.a=r[3] ?? 1;
	// 	}else{
	// 		this.r=r;
	// 		this.g=g!;
	// 		this.b=b!;
	// 		this.a=a ?? 1;
	// 	}
	// 	this.clearHSV();
	// 	return this;
	// }

	// public hsv(h:number, s:number, v:number, a?:number):this;
	// public hsv(array:number[]):this;
	// public hsv(h:number|number[],s?:number,v?:number,a?:number){
	// 	if(Array.isArray(h)){
	// 		this._hue=h[0] ?? 0;
	// 		this._sat=h[1] ?? 0;
	// 		this._val=h[2] ?? 0;
	// 		this.a=h[3] ?? 1;
	// 	}else{
	// 		this._hue=h;
	// 		this._sat=s!;
	// 		this._val=v!;
	// 		this.a=a!;
	// 	}
	// 	this.updateRGB();
	// 	return this;
	// }

	public rgbDist(that:Color){
		return Math.sqrt((this.r-that.r)**2+(this.g-that.g)**2+(this.b-that.b)**2);
	}

	public hsvPosition(out=new math.Vec3()){
		this.updateHSV();
		const hue=this._hue!*math.D2R;
		out.x=math.cos(hue);
		out.y=math.sin(hue);

		const sat=this._sat!*math.PIHALF;
		out.z=math.cos(sat);
		const sinSat=math.sin(sat);
		out.x*=sinSat;
		out.y*=sinSat;

		const val=this._val!;
		out.x*=val;
		out.y*=val;
		out.z*=val;
		return out;
	}

	public html(includeAlpha=true){
		const r=Math.min(Math.max(Math.round(this.r*255),0),255);
		const g=Math.min(Math.max(Math.round(this.g*255),0),255);
		const b=Math.min(Math.max(Math.round(this.b*255),0),255);
		const a=Math.min(Math.max(Math.round(this.a*255),0),255);

		let s=`#${toHexComponent(r)}${toHexComponent(g)}${toHexComponent(b)}`;
		if(includeAlpha && a!=255)
			s+=toHexComponent(a);
		return s;
	}

	public htmlRgb(){
		if(this.a!=1)
			return `rgba(${Math.round(this.r*255).toString()},${Math.round(this.g*255).toString()},${Math.round(this.b*255).toString()},${this.a.toFixed(2)})`;
		return `rgb(${Math.round(this.r*255).toString()},${Math.round(this.g*255).toString()},${Math.round(this.b*255).toString()})`;
	}

	public toString(){
		return this.html();
	}

	public to32bit(){
		const r=Math.min(Math.max(Math.round(this.r*255),0),255);
		const g=Math.min(Math.max(Math.round(this.g*255),0),255);
		const b=Math.min(Math.max(Math.round(this.b*255),0),255);
		const a=Math.min(Math.max(Math.round(this.a*255),0),255);

		return (
			(a<<24)|
			(b<<16)|
			(g<<8)|
			(r<<0)
		);
	}

	public toJSON(){
		return this.html();
	}

	public toArray(array:number[]=new Array(4), i=0):number[]{
		array[i+0]=this.r;
		array[i+1]=this.g;
		array[i+2]=this.b;
		array[i+3]=this.a;
		return array;
	}

	public toVec4(out?:math.Vec4):math.Vec4{
		if(!out)
			return new math.Vec4(this.r,this.g,this.b,this.a);
		out.x=this.r;
		out.y=this.g;
		out.z=this.b;
		out.w=this.a;
		return out;
	}

	// public threeColor():three.Color{
	// 	return new three.Color(this.r,this.g,this.b);
	// }

	// public scale(f:number){
	// 	this.clearHSV();
	// 	this.r*=f;
	// 	this.g*=f;
	// 	this.b*=f;
	// 	this.a*=f;
	// 	return this;
	// }

	// public add(that:Color){
	// 	this.clearHSV();
	// 	this.r+=that.r;
	// 	this.g+=that.g;
	// 	this.b+=that.b;
	// 	this.a+=that.a;
	// 	return this;
	// }

	public scale(r:number, g=r, b=g, a=b){
		return new Color(true,
			this.r*r,
			this.g*g,
			this.b*b,
			this.a*a,
		);
	}

	public addScaled(that:Color, f:number){
		return new Color(true,
			this.r+that.r*f,
			this.g+that.g*f,
			this.b+that.b*f,
			this.a+that.a*f,
		);
	}

	public lerp(that:Color, f:number){
		return new Color(true,
			math.lerp(this.r,that.r,f),
			math.lerp(this.g,that.g,f),
			math.lerp(this.b,that.b,f),
			math.lerp(this.a,that.a,f),
		);
	}

	public neg(){
		return new Color(true,1-this.r,1-this.g,1-this.b,this.a);
	}


}

// export class Color extends Color{
// 	public constructor(
// 		isRGB:boolean,
// 		x:number,
// 		y:number,
// 		z:number,
// 		a:number
// 	){
// 		super(isRGB,x,y,z,a);
// 	}

// 	public copy(that:Color){
// 		return this;
// 	}

// 	public red():number;
// 	public red(v:number):this;
// 	public red(v?:number){
// 		if(typeof(v)==='number')
// 			return this;
// 		return super.r;
// 	}

// 	public green():number;
// 	public green(v:number):this;
// 	public green(v?:number){
// 		if(typeof(v)==='number')
// 			return this;
// 		return super.g;
// 	}

// 	public blue():number;
// 	public blue(v:number):this;
// 	public blue(v?:number){
// 		if(typeof(v)==='number')
// 			return this;
// 		return super.b;

// 	}

// 	public hue():number;
// 	public hue(v:number):this;
// 	public hue(v?:number){
// 		if(typeof(v)==='number')
// 			return this;
// 		return super.hue();
// 	}

// 	public saturation():number;
// 	public saturation(v:number):this;
// 	public saturation(v?:number){
// 		if(typeof(v)==='number')
// 			return this;
// 		return super.sat();
// 	}

// 	public value():number;
// 	public value(v:number):this;
// 	public value(v?:number){
// 		if(typeof(v)==='number')
// 			return this;
// 		return super.value();
// 	}

// 	public alpha():number;
// 	public alpha(v:number):this;
// 	public alpha(v?:number){
// 		if(typeof(v)==='number')
// 			return this;
// 		return super.alpha();
// 	}

// 	public rgb(r:number, g:number, b:number, a?:number):this;
// 	public rgb(array:number[]):this;
// 	public rgb(r:number|number[],g?:number,b?:number,a?:number){
// 		return this;
// 	}

// 	public hsv(h:number, s:number, v:number, a?:number):this;
// 	public hsv(array:number[]):this;
// 	public hsv(h?:number|number[],s?:number,v?:number,a?:number){
// 		return this;
// 	}

// 	public scale(f:number){
// 		return this;
// 	}

// 	public add(that:Color){
// 		return this;
// 	}

// 	public addScaled(that:Color, f:number){
// 		return this;
// 	}

// 	public lerp(that:Color, f:number){
// 		return this;
// 	}

// 	public negate(){
// 		return this;
// 	}
// }

export namespace Color{
	export function fromArray(a:number[]){
		return rgb(
			a[0] ?? 0,
			a[1] ?? 0,
			a[2] ?? 0,
			a[3] ?? 1,
		);
	}

	export function uniqueHue(index:number){
		if(index<3)
			return index*120;
		//this formula is infinit subdivision
		const level=3/2*Math.pow(2,Math.ceil(Math.log2((index+1)/3)));
		return 360*(0.5+index-level)/level;
	}

	export function uniqueHueColor(index:number, s:number, v:number, a=1){
		return hsv(uniqueHue(index),s,v);
	}

	export function random(){
		const red=Math.random();
		const green=Math.random();
		const blue=Math.random();
		return new Color(true,red,green,blue,1);
	}

	export function rgb(r:number,g:number,b:number,a=1){
		r=Math.min(Math.max(r,0),1);
		g=Math.min(Math.max(g,0),1);
		b=Math.min(Math.max(b,0),1);
		a=Math.min(Math.max(a,0),1);
		return new Color(true,r,g,b,a);
	}

	export function hsv(h:number,s:number,v:number,a=1){
		h=h%360;
		s=Math.min(Math.max(s,0),1);
		v=Math.min(Math.max(v,0),1);
		a=Math.min(Math.max(a,0),1);
		const [r,g,b]=hsvToRgb(h,s,v);
		return new Color(true,r,g,b,a);
	}

	// export function named(name:HtmlName|Color){
	// 	if(name instanceof Color)
	// 		return name;
	// 	else
	// 		return htmlNames[name];
	// }

	export function html(color:string|Color):Color;
	export function html(color:string|Color,Type:typeof Color):Color;
	export function html(color:string|Color,Type=Color):Color|null{
		if(color instanceof Color)
			return color;
		if(!color)
			return null;
		let matches:RegExpMatchArray|null;
		if(matches=color.match(/^#([0-9A-F]{1})([0-9A-F]{1})([0-9A-F]{1})$/i))
			return new Type(true,parseInt(matches[1],16)/15,parseInt(matches[2],16)/15,parseInt(matches[3],16)/15,1);

		if(matches=color.match(/^#([0-9A-F]{2})([0-9A-F]{2})([0-9A-F]{2})$/i))
			return new Type(true,parseInt(matches[1],16)/255,parseInt(matches[2],16)/255,parseInt(matches[3],16)/255,1);

		if(matches=color.match(/^#([0-9A-F]{2})([0-9A-F]{2})([0-9A-F]{2})([0-9A-F]{2})$/i))
			return new Type(true,parseInt(matches[1],16)/255,parseInt(matches[2],16)/255,parseInt(matches[3],16)/255,parseInt(matches[4],16)/255);

		if(matches=color.match(/^rgb\(\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)\s*\)$/i))
			return new Type(true,parseInt(matches[1])/255,parseInt(matches[2])/255,parseInt(matches[3])/255,1);

		if(matches=color.match(/^rgba?\(\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*(\d*\.?\d+)\s*\)$/i))
			return new Type(true,parseInt(matches[1])/255,parseInt(matches[2])/255,parseInt(matches[3])/255,parseFloat(matches[4]));

		if(named[<Name>color]!==undefined)
			return named[<Name>color];

		// console.error(`bad color format "${color}"`);
		return null;
	}

	// export const white=
	// export function white(){
	// 	return new Color(true,1,1,1,1);
	// }

	// export function black(){
	// 	return new Color(true,0,0,0,1);
	// }

	// export function transparent(){
	// 	return new Color(true,0,0,0,0);
	// }

	// These colors are standard html colors. DO NOT CHANGE THE VALUES HERE, PLEASE.
	export const named=Object.freeze({
		transparent: html('#00000000',Color),
		black: html('#000000',Color),
		silver: html('#c0c0c0',Color),
		gray: html('#808080',Color),
		white: html('#ffffff',Color),
		maroon: html('#800000',Color),
		red: html('#ff0000',Color),
		purple: html('#800080',Color),
		fuchsia: html('#ff00ff',Color),
		green: html('#008000',Color),
		lime: html('#00ff00',Color),
		olive: html('#808000',Color),
		yellow: html('#ffff00',Color),
		navy: html('#000080',Color),
		blue: html('#0000ff',Color),
		teal: html('#008080',Color),
		aqua: html('#00ffff',Color),
		orange: html('#ffa500',Color),
		aliceblue: html('#f0f8ff',Color),
		antiquewhite: html('#faebd7',Color),
		aquamarine: html('#7fffd4',Color),
		azure: html('#f0ffff',Color),
		beige: html('#f5f5dc',Color),
		bisque: html('#ffe4c4',Color),
		blanchedalmond: html('#ffebcd',Color),
		blueviolet: html('#8a2be2',Color),
		brown: html('#a52a2a',Color),
		burlywood: html('#deb887',Color),
		cadetblue: html('#5f9ea0',Color),
		chartreuse: html('#7fff00',Color),
		chocolate: html('#d2691e',Color),
		coral: html('#ff7f50',Color),
		cornflowerblue: html('#6495ed',Color),
		cornsilk: html('#fff8dc',Color),
		crimson: html('#dc143c',Color),
		cyan: html('#00ffff',Color),
		darkblue: html('#00008b',Color),
		darkcyan: html('#008b8b',Color),
		darkgoldenrod: html('#b8860b',Color),
		darkgray: html('#a9a9a9',Color),
		darkgreen: html('#006400',Color),
		darkgrey: html('#a9a9a9',Color),
		darkkhaki: html('#bdb76b',Color),
		darkmagenta: html('#8b008b',Color),
		darkolivegreen: html('#556b2f',Color),
		darkorange: html('#ff8c00',Color),
		darkorchid: html('#9932cc',Color),
		darkred: html('#8b0000',Color),
		darksalmon: html('#e9967a',Color),
		darkseagreen: html('#8fbc8f',Color),
		darkslateblue: html('#483d8b',Color),
		darkslategray: html('#2f4f4f',Color),
		darkslategrey: html('#2f4f4f',Color),
		darkturquoise: html('#00ced1',Color),
		darkviolet: html('#9400d3',Color),
		deeppink: html('#ff1493',Color),
		deepskyblue: html('#00bfff',Color),
		dimgray: html('#696969',Color),
		dimgrey: html('#696969',Color),
		dodgerblue: html('#1e90ff',Color),
		firebrick: html('#b22222',Color),
		floralwhite: html('#fffaf0',Color),
		forestgreen: html('#228b22',Color),
		gainsboro: html('#dcdcdc',Color),
		ghostwhite: html('#f8f8ff',Color),
		gold: html('#ffd700',Color),
		goldenrod: html('#daa520',Color),
		greenyellow: html('#adff2f',Color),
		grey: html('#808080',Color),
		honeydew: html('#f0fff0',Color),
		hotpink: html('#ff69b4',Color),
		indianred: html('#cd5c5c',Color),
		indigo: html('#4b0082',Color),
		ivory: html('#fffff0',Color),
		khaki: html('#f0e68c',Color),
		lavender: html('#e6e6fa',Color),
		lavenderblush: html('#fff0f5',Color),
		lawngreen: html('#7cfc00',Color),
		lemonchiffon: html('#fffacd',Color),
		lightblue: html('#add8e6',Color),
		lightcoral: html('#f08080',Color),
		lightcyan: html('#e0ffff',Color),
		lightgoldenrodyellow: html('#fafad2',Color),
		lightgray: html('#d3d3d3',Color),
		lightgreen: html('#90ee90',Color),
		lightgrey: html('#d3d3d3',Color),
		lightpink: html('#ffb6c1',Color),
		lightsalmon: html('#ffa07a',Color),
		lightseagreen: html('#20b2aa',Color),
		lightskyblue: html('#87cefa',Color),
		lightslategray: html('#778899',Color),
		lightslategrey: html('#778899',Color),
		lightsteelblue: html('#b0c4de',Color),
		lightyellow: html('#ffffe0',Color),
		limegreen: html('#32cd32',Color),
		linen: html('#faf0e6',Color),
		magenta: html('#ff00ff',Color),
		mediumaquamarine: html('#66cdaa',Color),
		mediumblue: html('#0000cd',Color),
		mediumorchid: html('#ba55d3',Color),
		mediumpurple: html('#9370db',Color),
		mediumseagreen: html('#3cb371',Color),
		mediumslateblue: html('#7b68ee',Color),
		mediumspringgreen: html('#00fa9a',Color),
		mediumturquoise: html('#48d1cc',Color),
		mediumvioletred: html('#c71585',Color),
		midnightblue: html('#191970',Color),
		mintcream: html('#f5fffa',Color),
		mistyrose: html('#ffe4e1',Color),
		moccasin: html('#ffe4b5',Color),
		navajowhite: html('#ffdead',Color),
		oldlace: html('#fdf5e6',Color),
		olivedrab: html('#6b8e23',Color),
		orangered: html('#ff4500',Color),
		orchid: html('#da70d6',Color),
		palegoldenrod: html('#eee8aa',Color),
		palegreen: html('#98fb98',Color),
		paleturquoise: html('#afeeee',Color),
		palevioletred: html('#db7093',Color),
		papayawhip: html('#ffefd5',Color),
		peachpuff: html('#ffdab9',Color),
		peru: html('#cd853f',Color),
		pink: html('#ffc0cb',Color),
		plum: html('#dda0dd',Color),
		powderblue: html('#b0e0e6',Color),
		rosybrown: html('#bc8f8f',Color),
		royalblue: html('#4169e1',Color),
		saddlebrown: html('#8b4513',Color),
		salmon: html('#fa8072',Color),
		sandybrown: html('#f4a460',Color),
		seagreen: html('#2e8b57',Color),
		seashell: html('#fff5ee',Color),
		sienna: html('#a0522d',Color),
		skyblue: html('#87ceeb',Color),
		slateblue: html('#6a5acd',Color),
		slategray: html('#708090',Color),
		slategrey: html('#708090',Color),
		snow: html('#fffafa',Color),
		springgreen: html('#00ff7f',Color),
		steelblue: html('#4682b4',Color),
		tan: html('#d2b48c',Color),
		thistle: html('#d8bfd8',Color),
		tomato: html('#ff6347',Color),
		turquoise: html('#40e0d0',Color),
		violet: html('#ee82ee',Color),
		wheat: html('#f5deb3',Color),
		whitesmoke: html('#f5f5f5',Color),
		yellowgreen: html('#9acd32',Color),
		rebeccapurple: html('#663399',Color),
	});
	export type Name=keyof typeof named;

	const friendlyNames={
		'black': Color.hsv(0,0,0),
		'dark gray': Color.hsv(0,0,0.25),
		'gray': Color.hsv(0,0,0.5),
		'light-gray': Color.hsv(0,0,0.75),
		'white': Color.hsv(0,0,1),
		'red': Color.hsv(0,1,1),
		'dark red': Color.hsv(0,1,0.5),
		'orange': Color.hsv(40,1,1),
		'dark orange': Color.hsv(40,1,0.5),
		'yellow': Color.hsv(60,1,1),
		'dark yellow': Color.hsv(40,1,0.5),
		'bright green': Color.hsv(120,1,1),
		'green': Color.hsv(120,1,0.5),
		'dark green': Color.hsv(120,1,0.25),
		'cyan': Color.hsv(180,1,1),
		'dark cyan': Color.hsv(180,1,0.5),
		'blue': Color.hsv(240,1,1),
		'dark blue': Color.hsv(240,1,0.5),
		'bluish purple': Color.hsv(270,1,1),
		'magenta': Color.hsv(300,1,1),
		'purple': Color.hsv(300,1,0.5),
	};

	const friendlyPositions=new Map(Object.entries(friendlyNames).map(([name,color])=>[name,color.hsvPosition()]));

	export function friendlyName(color:Color){
		let closestName='unknown';
		let closestDist=Infinity;

		const wantedPosition=color.hsvPosition();
		for(const [name,position] of friendlyPositions){
			const dist=wantedPosition.distTo(position);
			if(closestDist>dist){
				closestDist=dist;
				closestName=name;
			}
		}
		return closestName;
	}

}
